export const WHITE = '#fefefe'
export const SILVER = '#e1e8f0'
export const GRAY = '#97abc0'
export const BLACK = '#001e3e'

export const DARK_BLUE = '#00356c'
export const BLUE = '#2586eb'
export const YELLOW = '#ffda5d'
export const RED = '#dd4e2b'



// WEBPACK FOOTER //
// ./src/styles/colors.js